"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowCheckBoxEditor_1 = require("../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var AppPaySystemEditor = /** @class */ (function (_super) {
    __extends(AppPaySystemEditor, _super);
    function AppPaySystemEditor(props) {
        return _super.call(this, props) || this;
    }
    AppPaySystemEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    title: _item.title,
                    apikey: _item.apikey,
                    callback_url: _item.callback_url,
                    description: _item.description,
                    is_locked: _item.is_locked,
                    brand_id: _item.brand_id,
                    brand_title: _item.brand_title
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Изменить платежный сервис"]);
                });
            }
        }
        else {
            this.setState({
                title: "",
                apikey: "",
                callback_url: "",
                description: "",
                is_locked: false,
                brand_id: 0,
                brand_title: ""
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Создать платежный сервис"]);
            });
        }
        this.doReSetRules();
    };
    AppPaySystemEditor.prototype.doReSetRules = function () {
        this.setState({
            title_rules: { isError: false },
            apikey_rules: { isError: false },
            callback_url_rules: { isError: false },
            brand_rules: { isError: false }
        });
    };
    AppPaySystemEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                title: this.state.title,
                apikey: this.state.apikey,
                callback_url: this.state.callback_url,
                is_locked: this.state.is_locked,
                description: this.state.description,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Платежный сервис изменен!");
            });
        }
    };
    AppPaySystemEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({
                title_rules: {
                    isError: true,
                    errorMessage: "Название сервиса не заполнено!"
                }
            });
            return false;
        }
        if ((!this.state.apikey) || (this.state.apikey.length === 0)) {
            this.setState({
                apikey_rules: {
                    isError: true,
                    errorMessage: "Апи ключ не заполнен!"
                }
            });
            return false;
        }
        if ((this.state.brand_id == 0) || (this.state.brand_title.length === 0)) {
            this.setState({
                brand_rules: {
                    isError: true,
                    errorMessage: "Бренд не заполнен!"
                }
            });
            return false;
        }
        return true;
    };
    AppPaySystemEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                title: this.state.title,
                apikey: this.state.apikey,
                callback_url: this.state.callback_url,
                is_locked: this.state.is_locked,
                description: this.state.description,
                brand_id: this.state.brand_id
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Платежный сервис добавлен");
            });
        }
    };
    AppPaySystemEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    AppPaySystemEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить платежный сервис";
        }
        else {
            return "Изменить платежный сервис";
        }
    };
    AppPaySystemEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 470 },
            React.createElement(CardRowTextEditor_1.default, { texts: {
                    caption: "Название сервиса",
                    placeholder: "Введите название сервиса"
                }, value: this.state.title, onValueChanged: function (newVal) {
                    _this.setState({
                        title: newVal,
                        title_rules: { isError: false }
                    });
                }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: {
                    caption: "Api ключ",
                    placeholder: "Введите значение api ключа"
                }, value: this.state.apikey, onValueChanged: function (newVal) {
                    _this.setState({
                        apikey: newVal,
                        apikey_rules: { isError: false }
                    });
                }, required: true, rules: this.state.apikey_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: {
                    caption: "Callback ссылка",
                    placeholder: "Введите значение callback ссылки"
                }, value: this.state.callback_url, onValueChanged: function (newVal) {
                    _this.setState({
                        callback_url: newVal,
                        callback_url_rules: { isError: false }
                    });
                }, required: true, rules: this.state.callback_url_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: {
                    caption: "Описание",
                    placeholder: "Введите описание"
                }, value: this.state.description, onValueChanged: function (newVal) {
                    _this.setState({
                        description: newVal
                    });
                } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: {
                    caption: "Бренд сервиса",
                    placeholder: "Выберите бренд сервиса"
                }, value: { key: this.state.brand_id, value: this.state.brand_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        brand_id: newVal.key,
                        brand_title: newVal.value,
                        brand_rules: { isError: false }
                    });
                }, items: this.props.availBrands, disabled: this.props.record != null, required: true, rules: this.state.brand_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Заблокирован", value: this.state.is_locked, onChecked: function (checked) {
                    _this.setState({
                        is_locked: checked
                    });
                } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: {
                    btnEdit: "Изменить",
                    btnNew: "Создать",
                    btnGoBack: "Назад"
                }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return AppPaySystemEditor;
}(React.Component));
exports.default = AppPaySystemEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/app_paysystem/ui/component/AppPaySystemEditor.tsx
// module id = 2569
// module chunks = 0